export const setAircraftDetails = (aircraftDetails) => ({
    type: "SET_AIRCRAFT_DETAILS",
    payload: aircraftDetails,
  });